module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "couponName",
      "label": "优惠券名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "couponCode",
      "label": "优惠券编码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useStatus",
      "label": "使用状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm._f("useStatusFilter")(scope.row.useStatus, _vm.useStatusOptions)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "使用时间",
      "prop": "useTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单",
      "prop": "orderNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优惠金额(元)",
      "prop": "couponAmount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("¥" + _vm._s(_vm._f("0")(scope.row.couponAmount)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "过期时间",
      "prop": "endTime"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created",
      "label": "领取时间"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.searchForm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.searchForm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.searchForm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-829d2210","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/subscriber/components/subscriberCoupon.vue
// module id = 1714
// module chunks = 0